// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2AGZK","title":"Images45_title__33OmI","images":"Images45_images__3tJw_"};